var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import * as _ from "lodash";
import experimentSearchConstants from "./ExperimentSearchConstants.js";
const getDefaultState = {
  experimentSearchResult: null,
  managementGroups: null,
  isolationGroups: {},
  otherSearchFields: [],
  subManagementGroupValues: {
    values: {}
  },
  scorecardLinks: [],
  isLoading: false,
  error: false,
  status: {},
  selectedValues: {}
};
const updateGetAllExps = (state, actionResult) => {
  let newState = _.cloneDeep(state);
  if (actionResult.payload.Error) {
    newState.error = true;
  } else {
    newState.error = false;
  }
  newState.experimentSearchResult = actionResult.payload.Results;
  newState.isLoading = false;
  return newState;
};
const updateIsolationGroups = (state, actionResult) => {
  let newState = _.cloneDeep(state);
  const result = actionResult.payload;
  newState.isolationGroups[result.id] = result.flightControlData.IsolationGroupsOwned;
  return newState;
};
const updateSubMgmtGrpData = (state, actionResult) => {
  let newState = _.cloneDeep(state);
  const result = actionResult.payload;
  newState.subManagementGroupValues[result.url] = result.subMgmtGroupData;
  return newState;
};
const ExperimentSearchReducer = (state = getDefaultState, actionResult) => {
  switch (actionResult.type) {
    case experimentSearchConstants.LOAD_EXP_SEARCH:
      return __spreadProps(__spreadValues({}, state), {
        isLoading: true
      });
    case experimentSearchConstants.GET_ALL_EXPS:
      return updateGetAllExps(state, actionResult);
    case experimentSearchConstants.GET_ALL_SCORECARDS:
      return __spreadProps(__spreadValues({}, state), {
        scorecardLinks: actionResult.payload
      });
    case experimentSearchConstants.UPDATE_MGMT_GROUPS:
      return __spreadProps(__spreadValues({}, state), {
        managementGroups: actionResult.payload
      });
    case experimentSearchConstants.UPDATE_ISOLATION_GROUPS:
      return updateIsolationGroups(state, actionResult);
    case experimentSearchConstants.UPDATE_OTHER_SEARCH_FIELDS:
      return __spreadProps(__spreadValues({}, state), {
        otherSearchFields: actionResult.payload.SearchExperience
      });
    case experimentSearchConstants.UPDATE_SUB_MGMT_GRPS:
      return updateSubMgmtGrpData(state, actionResult);
    case experimentSearchConstants.HANDLE_SUB_MGMT_STATE:
      return __spreadProps(__spreadValues({}, state), {
        subManagementGroupValues: __spreadProps(__spreadValues({}, state.subManagementGroupValues), {
          values: actionResult.payload
        })
      });
    case experimentSearchConstants.UPDATE_STATUS_DATA:
      return __spreadProps(__spreadValues({}, state), {
        status: actionResult.payload
      });
    case experimentSearchConstants.UPDATE_SELECTED_VALUES:
      return __spreadProps(__spreadValues({}, state), {
        selectedValues: {
          managementGroup: actionResult.managementGroup,
          isolationGroup: actionResult.isolationGroup,
          trafficFilters: actionResult.trafficFilters
        }
      });
    default:
      return state;
  }
};
export {
  ExperimentSearchReducer,
  ExperimentSearchReducer as default
};
//# sourceMappingURL=ExperimentSearchReducer.js.map
